import comp from "./ResourceView";
export default comp;
